import { ExaminerRoleEnum } from 'api';

export const ODP_ASSESSMENT_ROLES = [
  ExaminerRoleEnum.LocalVideoCallSpeakingFlexi,
  ExaminerRoleEnum.LocalVideoCallSpeakingFull,
  ExaminerRoleEnum.GlobalVideoCallSpeakingFlexi,
  ExaminerRoleEnum.VCSFullIELTSUKVI,
  ExaminerRoleEnum.IOL,
  ExaminerRoleEnum.OnlineMarking,
  ExaminerRoleEnum.SpeakingESM,
  ExaminerRoleEnum.RSS,
  ExaminerRoleEnum.VCSLSA1,
  ExaminerRoleEnum.VCSLSA2,
  ExaminerRoleEnum.VCSLSB1,
];

export const ONLINE_SPEAKING_ROLES = [
  ExaminerRoleEnum.IELTSSpeakingStandard,
  ExaminerRoleEnum.LocalVideoCallSpeakingFlexi,
  ExaminerRoleEnum.LocalVideoCallSpeakingFull,
  ExaminerRoleEnum.GlobalVideoCallSpeakingFlexi,
  ExaminerRoleEnum.VCSFullIELTSUKVI,
  ExaminerRoleEnum.IOL,
  ExaminerRoleEnum.OnlineMarking,
  ExaminerRoleEnum.SpeakingESM,
];

export const odpAssessmentAllowed = (assignedRolesIds?: string[]): boolean =>
  assignedRolesIds?.some((roleId) => ODP_ASSESSMENT_ROLES.includes(roleId as ExaminerRoleEnum)) ??
  false;
